import angular from 'angular';
import {
  ssDialogService,
  loaderService,
  reportsDataService
} from 'app/services';
import {
  alerts,
  actionIcon
} from 'app/components/global';
import controller from './edit-report-schedule-dialog.controller';
import template from './edit-report-schedule-dialog.html';
import scheduleDateMessagesTpl from './messages/schedule.date.messages.html';
import scheduleDescriptionMessagesTpl from './messages/schedule.description.messages.html';
import scheduleNameMessagesTpl from './messages/schedule.name.messages.html';
import monthlyDayOfMonthMessagesTpl from './messages/schedule.monthly-day-of-month.messages.html';


export class dialogService {
  getOptions($event, { schedule = null, reportRecipients = null }) {
    return {
      controller,
      controllerAs: 'editReportScheduleDialogVM',
      locals: {
        schedule,
        reportRecipients,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.reports.editReportScheduleDialog', [
  ssDialogService,
  loaderService,
  reportsDataService,
  alerts,
  actionIcon
])
  .service('editReportScheduleDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('schedule.date.messages.html', scheduleDateMessagesTpl);
    $templateCache.put('schedule.description.messages.html', scheduleDescriptionMessagesTpl);
    $templateCache.put('schedule.name.messages.html', scheduleNameMessagesTpl);
    $templateCache.put('schedule.monthly-day-of-month.messages.html', monthlyDayOfMonthMessagesTpl);
  })
  .name;

console.log('app.components.reports.editReportScheduleDialog created');
